import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://udbalkvzfnfalfyhcnta.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVkYmFsa3Z6Zm5mYWxmeWhjbnRhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTkzNTM5MjQsImV4cCI6MjA3NDkyOTkyNH0.djB5t7SPtfBuwpV5O0nX7erZL8Gkf_fZxph3cflT5HI";

export const supabase = createClient(supabaseUrl, supabaseKey);
